@if (notifications.message(); as message) {
  <div class="toast toast-top toast-end z-50" role="alert" aria-live="assertive">
    <div class="alert alert-error">
      <span>{{ message }}</span>
      <button
        class="btn btn-sm"
        type="button"
        aria-label="Fehlermeldung schließen"
        (click)="notifications.dismiss()"
      >
        Schließen
      </button>
    </div>
  </div>
}
